module.exports = __webpack_public_path__ + "images/FUSA_icons/079-box-2.d679e7375a763da33658636e4b28da6c.svg";